module.exports = __webpack_public_path__ + "static/media/[Annual_Oration]2018.d0b5b70f.md";